import { ContentPage } from '@/components/content-page'
import { AdminUsers } from '@/components/admin-users'
import { AdminForumReports } from '@/components/admin-forum'
import { AdminForumLogins } from '@/components/admin-forum-logins'
import { AdminFileDrops } from '@/components/admin-file-drops'
import { AdminProgrammerStats } from '@/components/admin-programmer-stats'

export default function AdminPage() {
  return (
    <ContentPage
      eyebrow="// admin"
      title="Community administration"
      description="Review quarantined uploads, Web Programmer beta usage, registered users, forum badges, and member reports."
    >
      <div className="flex flex-col gap-6">
        <AdminForumLogins />
        <AdminForumReports />
        <AdminProgrammerStats />
        <AdminFileDrops />
        <AdminUsers />
      </div>
    </ContentPage>
  )
}
